import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { ContractRawValuesService } from 'brain-data/service/utility/contract-raw-values.service';
import {
  loadContractRawValues,
  loadContractRawValuesError,
  loadContractRawValuesSuccess,
} from '../actions/contract-raw-values.action';

@Injectable()
export class ContractRawValuesEffects {
  loadContractRawValues$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadContractRawValues),
      mergeMap(({ contractNumber }) =>
        this.service.getByContractNumber(contractNumber).pipe(
          map(values => loadContractRawValuesSuccess({ contractNumber, values })),
          catchError((error: Error) => of(loadContractRawValuesError({ contractNumber, error }))),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private service: ContractRawValuesService,
  ) {}
}
